const seoTextSlide = () => {
	const slides = document.querySelectorAll(".seo__text-slide");

		slides.forEach(slide => {
			if (slide.dataset.marqueeInitialized === "true") return;

			const firstChild = slide.firstElementChild;
			if (!firstChild) return;

			slide.dataset.marqueeInitialized = "true";

			let previousWidth = -1;

			const buildLoop = () => {

				slide.querySelectorAll(
					":scope > [data-marquee-clone]"
				).forEach(clone => clone.remove());

				firstChild.style.animation = "none";

				const itemWidth = firstChild.getBoundingClientRect().width;
				const containerWidth = slide.clientWidth;

				if (!itemWidth || !containerWidth) return;

				const totalCopies = Math.max(
					2,
					Math.ceil(containerWidth / itemWidth) + 1
				);

				for (let index = 1; index < totalCopies; index++) {
					const clone = firstChild.cloneNode(true);

					clone.setAttribute("data-marquee-clone", "");
					clone.setAttribute("aria-hidden", "true");
					clone.setAttribute("inert", "");
					clone.removeAttribute("id");

					clone.querySelectorAll("[id]").forEach(element => {
						element.removeAttribute("id");
					});

					slide.appendChild(clone);
				}

				const items = [
					firstChild,
					...slide.querySelectorAll(
						":scope > [data-marquee-clone]"
					)
				];

				void slide.offsetWidth;

				items.forEach(item => {
					item.style.animation =
						"seo-marquee-flex 25s linear infinite";
				});
			};

			const startLoop = () => {
				buildLoop();
				previousWidth = slide.clientWidth;

				const observer = new ResizeObserver(() => {
					const currentWidth = slide.clientWidth;

					if (currentWidth === previousWidth) return;

					previousWidth = currentWidth;
					buildLoop();
				});

				observer.observe(slide);
			};

			if (document.fonts?.ready) {
				document.fonts.ready.then(startLoop);
			} else {
				startLoop();
			}
		});

		// height slider inner
		const sliderInners = document.querySelectorAll(
			".equipo .slider__inner"
		);

		sliderInners.forEach(sliderInner => {
			const section = sliderInner.closest("section");
			const seoText = section?.querySelector(".seo__text-slide");
			const sliderList = sliderInner.querySelector(
				".content-link__list"
			);

			if (!sliderList) return;

			const updateSliderHeight = () => {
				const contentHeight = Math.ceil(
					sliderList.getBoundingClientRect().height
				);

				sliderInner.style.setProperty(
					"--slider-content-height",
					`${contentHeight}px`
				);

				if (seoText) {
					seoText.style.setProperty(
						"--slider-content-height",
						`${contentHeight}px`
					);
				}
			};

			const resizeObserver = new ResizeObserver(updateSliderHeight);

			resizeObserver.observe(sliderList);
			window.addEventListener("resize", updateSliderHeight);

			if (document.fonts?.ready) {
				document.fonts.ready.then(updateSliderHeight);
			}

			updateSliderHeight();
		});
};

export { seoTextSlide };
